import { Button, styled } from '@material-ui/core';

export const Container = styled(Button)(({ theme }) => ({
  borderRadius: 8,
  background:
    theme.palette.type === 'dark'
      ? 'linear-gradient(to bottom, #161c25, #0d1117)'
      : 'linear-gradient(to bottom, #f4f4f4, #fff)',
  height: 180,
  width: '100%',
  border: theme.palette.type === 'dark' ? '1px solid #212933' : '1px solid #cdd9e9',
  padding: 10,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',

  '& .MuiButton-label': {
    display: 'flex',
    flexDirection: 'column',
    whiteSpace: 'normal',
  },

  '& .MuiSvgIcon-root': {
    height: 30,
    width: 30,
    marginBottom: 20,
  },
}));
